module.exports = __webpack_public_path__ + "img/barvaz_yes.01ebfe8a.png";